<template>
    <AdjustPriceDialog
            :dialogTitle="dialogTitle"
            :centerDialogVisible="visible"
            @updateVisible="updateVisible"
            @resetPopupData="resetPopupData"
            @submitPopupData="submitPopupData"
            :popupWidth="'500px'"
    >
        <el-form :model="query" label-width="100px">
            <el-form-item label="协议价:">
                <el-input v-model="query.agreementPrice"></el-input>
            </el-form-item>
        </el-form>
    </AdjustPriceDialog>
</template>

<script>
    import AdjustPriceDialog from '../../../../../components/common/epecDialog'
    import Api from '../../../api/agreement/index'
    export default {
        name: "adjustPriceDialog",
        components: {
            AdjustPriceDialog
        },
        props: {
            visible:{
                type:Boolean,
                required: true
            },
            priceId:{
                type:Number,
                required: true
            },
            supplierCompanyId:{
                type: Number,
                required: true
            },
            agreementId:{
                type:Number,
                required: true
            }
        },
        data() {
            return {
                dialogTitle:'调价',
                query:{
                    agreementPrice:''
                }

            }
        },
        computed: {},
        created() {
        },
        methods: {
            updateVisible(){

            },
            resetPopupData(){
                this.$emit('close')
            },
            submitPopupData(){
                this.adjustAgreementPrice()
                this.$emit('close')
                this.$emit('refresh')
                this.query.agreementPrice = ''
            },
            adjustAgreementPrice(){
                let params = {
                    priceId:this.priceId,
                    agreementPrice: parseFloat(this.query.agreementPrice),
                    supplierCompanyId : this.supplierCompanyId,
                    agreementId:this.agreementId
                }

                Api.updateAgreementPrice(params)
                    .then((res) => {
                        if(res.code == '200'){
                            this.$message({
                                type:'success',
                                message:'更新协议价成功'
                            })
                        }
                    })
            }
        }

    }
</script>

<style scoped>

</style>
